import { FetchError } from '../errors/FetchError'
import { fetchApi, fetchWithAuthorization } from './fetch'

/**
 * Envía una solicitud de eliminación de cuenta.
 * Endpoint público: lo consume el formulario del landing y también las apps móviles.
 */
export const submitAccountDeletionRequest = async (payload) => {
  try {
    const data = await fetchApi('/public/account-deletion', payload, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http failed to submit account deletion request')
  }
}

/**
 * Confirma la solicitud desde el enlace enviado al correo del solicitante.
 */
export const verifyAccountDeletionRequest = async (token) => {
  try {
    const data = await fetchApi(`/public/account-deletion/verify/${token}`)
    return data
  } catch (error) {
    throw new FetchError(error, 'Http failed to verify account deletion request')
  }
}

/**
 * Última solicitud del usuario autenticado. Devuelve data null si no tiene.
 */
export const fetchMyAccountDeletionRequest = async () => {
  try {
    const data = await fetchWithAuthorization('/account-deletion/me')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http failed to get my account deletion request')
  }
}

/**
 * Solicitud enviada desde el perfil por un usuario que ya inició sesión.
 * No pasa por el correo de confirmación: la sesión ya prueba la identidad.
 */
export const submitMyAccountDeletionRequest = async (payload) => {
  try {
    const data = await fetchWithAuthorization('/account-deletion/me', payload, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http failed to submit my account deletion request')
  }
}

/**
 * Listado paginado para el módulo root.
 */
export const fetchAccountDeletionRequests = async (page = 1, limit = 10, params = {}) => {
  try {
    const { search, status } = params
    let url = `/account-deletion?page=${page}&limit=${limit}`
    const term = typeof search === 'string' ? search.trim() : ''
    if (term) url += `&search=${encodeURIComponent(term)}`
    if (status) url += `&status=${status}`
    const data = await fetchWithAuthorization(url)
    return data
  } catch (error) {
    throw new FetchError(error, 'Http failed to get account deletion requests')
  }
}

/**
 * Conteo de solicitudes por estado.
 */
export const fetchAccountDeletionSummary = async () => {
  try {
    const data = await fetchWithAuthorization('/account-deletion/summary')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http failed to get account deletion summary')
  }
}

/**
 * Cambia el estado y la nota interna de una solicitud.
 */
export const updateAccountDeletionStatus = async (id, status, adminNotes) => {
  try {
    const data = await fetchWithAuthorization(
      `/account-deletion/${id}/status`,
      { status, admin_notes: adminNotes },
      'PUT'
    )
    return data
  } catch (error) {
    throw new FetchError(error, 'Http failed to update account deletion request')
  }
}

/**
 * Quita una solicitud del listado (soft delete en el backend).
 */
export const deleteAccountDeletionRequest = async (id) => {
  try {
    const data = await fetchWithAuthorization(`/account-deletion/${id}`, null, 'DELETE')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http failed to delete account deletion request')
  }
}

/* Etiquetas compartidas por el módulo root */

export const DELETION_STATUS_LABELS = {
  unverified: 'Sin confirmar',
  pending: 'Pendiente',
  in_process: 'En proceso',
  completed: 'Completada',
  rejected: 'Rechazada'
}

export const DELETION_STATUS_COLORS = {
  unverified: 'secondary',
  pending: 'warning',
  in_process: 'info',
  completed: 'success',
  rejected: 'danger'
}

// Se manda el texto tal cual al backend: la columna `reason` guarda lo que
// eligio o escribio el usuario, sin claves que haya que traducir despues.
export const DELETION_REASONS = [
  'Me mudo de condominio',
  'Problemas técnicos',
  'Ya no uso Homelan'
]

export const DELETION_REASON_OTHER = 'Otro'

export const DELETION_SOURCE_LABELS = {
  web: 'Web',
  android: 'Android',
  ios: 'iOS'
}
